//import 'bootstrap/dist/css/bootstrap.css';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import './styles/global/colors.css';
import './styles/components/AppPolish.css';
import { I18nProvider } from './i18n';
import { initializeAnalytics } from './lib/analytics';

initializeAnalytics();

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Auth0Provider
        domain={auth0Domain}
        clientId={auth0ClientId}
        redirectUri={window.location.origin}
        skipRedirectCallback={window.location.pathname === '/stripe/connect-return'}
        cacheLocation="localstorage"
        useRefreshTokens
        useRefreshTokensFallback
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: process.env.REACT_APP_API_AUDIENCE,
          scope: "openid profile email",
        }}
      >
        <BrowserRouter basename={baseUrl}>
          <I18nProvider>
             <Suspense fallback={<div style={{ textAlign: "center", paddingTop: "40px" }}>Loading...</div>}>
              <App />
            </Suspense>
          </I18nProvider>
        </BrowserRouter>
      </Auth0Provider>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});

let serviceWorkerRefreshing = false;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (serviceWorkerRefreshing) {
      return;
    }

    serviceWorkerRefreshing = true;
    window.location.reload();
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
